export const uk = {
    gteMessage: 'Сумма дневного бюджета не может быть больше {maxValue}',
    lteMessage: 'Сумма дневного бюджета не может быть меньше {minValue}',
    requiredMessage: 'Не указана сумма дневного бюджета'
};
